(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/quick-bets/assets/javascripts/quick-bet-section.js') >= 0) return;  svs.modules.push('/components/oddset/quick-bets/assets/javascripts/quick-bet-section.js');
"use strict";


const {
  QuickBetButton
} = svs.components.oddset.quickBets;
const {
  getOutcomeAriaLabel
} = svs.components.oddset.kambiOffering;
const QuickBetSection = _ref => {
  let {
    sectionTitle,
    betOffers,
    cssModifier
  } = _ref;
  return React.createElement("section", {
    className: "quick-bet-section"
  }, React.createElement("h2", {
    className: "quick-bet-section__header"
  }, sectionTitle), betOffers.map(betOffer => React.createElement("div", {
    className: "quick-bet-section-offer quick-bet-section-offer".concat(cssModifier),
    key: betOffer.key
  }, betOffer.outcomes.map(outcome => {
    if (outcome.placeholder) {
      return React.createElement("div", {
        className: "quick-bet-section-offer__placeholder",
        key: outcome.id
      });
    }
    return React.createElement(QuickBetButton, {
      ariaLabel: getOutcomeAriaLabel(outcome),
      className: "outcome-btn outcome-btn".concat(cssModifier, " ").concat(outcome.isSuspended || betOffer.isSuspended ? 'outcome-btn--disabled' : ''),
      disabled: outcome.isSuspended || betOffer.isSuspended,
      key: outcome.id,
      outcomeId: outcome.id,
      path: betOffer.deepLinkPath,
      trackingLabel: sectionTitle
    }, !outcome.odds ? '-' : "".concat(outcome.label, "\n ").concat(outcome.odds));
  }))));
};
setGlobal('svs.components.oddset.quickBets.QuickBetSection', QuickBetSection);

 })(window);